import { useMedia } from 'react-use';

const BREAKPOINT = 991 as const;

export const useIsMobile = () => useMedia(`(max-width: ${BREAKPOINT}px)`);
